// Main entry point for support page
import '../../styles/main.css';
import '../../styles/components.css';
import './support.css';
import { initSentry } from '../../shared/sentry-config.ts';
import * as Sentry from '@sentry/react';
import { trackPageView } from '../../shared/services/analyticsService.ts';
import { Header } from '../../components/landing/header.js';
import { redirectWithLanguage, getCurrentLanguage } from '../../shared/utils/urlUtils.ts';
import i18n from '../../shared/i18n/config.ts';

initSentry('web-support', 'support');

window.addEventListener('error', (e) => {
  console.error('Global error:', e.error);
  Sentry.captureException(e.error, {
    tags: { errorType: 'global' },
  });
});

window.addEventListener('unhandledrejection', (e) => {
  console.error('Unhandled promise rejection:', e.reason);
  Sentry.captureException(e.reason, {
    tags: { errorType: 'unhandledRejection' },
  });
});

function t(key, options = {}) {
  return i18n.t(key, options);
}

function updatePageText() {
  document.querySelectorAll('[data-i18n]').forEach((element) => {
    const key = element.getAttribute('data-i18n');
    if (key) {
      const translation = t(key);
      if (translation !== key) {
        element.textContent = translation;
      }
    }
  });

  document.title = `${t('support.hero.title')} - Gantty`;
  document.documentElement.lang = getCurrentLanguage();
}

document.addEventListener('DOMContentLoaded', async () => {
  const lang = getCurrentLanguage();

  localStorage.setItem('gantty_language', lang);
  document.documentElement.lang = lang;

  await i18n.changeLanguage(lang);

  document.title = `${t('support.hero.title')} - Gantty`;

  trackPageView('Support');

  const header = new Header();

  updatePageText();

  setTimeout(() => {
    if (header && typeof header.populateLanguageDropdown === 'function') {
      header.populateLanguageDropdown();
    }
  }, 100);

  i18n.on('languageChanged', (lng) => {
    document.documentElement.lang = lng;
    document.title = `${t('support.hero.title')} - Gantty`;
    updatePageText();
    if (header && typeof header.populateLanguageDropdown === 'function') {
      header.populateLanguageDropdown();
    }
  });

  document.getElementById('loginBtn')?.addEventListener('click', async () => {
    redirectWithLanguage('/login');
  });
});
